import React from "react";
import './App.css';
import LoginPage from './Auth/LoginPage';
import PageLayout from "./Layout/PageLayout";
import requests from './Auth/Requests'
import EventBus from './EventBus';

export default class App extends React.Component {
    state = {
        loggedIn: false
    }

    loggedIn = () => {
        this.setState({ loggedIn: true });
    }

    loggedOut = (unregisterDevice) => {
        requests.logout(unregisterDevice);

        this.setState({ loggedIn: false });
    }

    routePage = () => {
        if (!this.state.loggedIn) {
            return <LoginPage />;
        }

        return <PageLayout />;
    }

    render() {
        return (
            <>
                {this.routePage()}
            </>
        )
    }

    componentDidMount() {
        EventBus.on("login", this.loggedIn);
        EventBus.on("logout", this.loggedOut);
    }

    componentWillUnmount() {
        EventBus.off("login", this.loggedIn);
        EventBus.off("logout", this.loggedOut);
    }
}